import gql from "graphql-tag";
import GraphQLClient, { RequestParam } from "../api";
import { RecentlyEditedManuscript, RecentlyEditedManuscriptsInput } from "../models/recentlyEditedManuscript";

interface IRecentlyEditedManuscriptsClient {
  list: (args: RecentlyEditedManuscriptsInput) => Promise<RecentlyEditedManuscript[]>;
}

export class RecentlyEditedManuscriptsClient implements IRecentlyEditedManuscriptsClient {
  async list({ limit }: RecentlyEditedManuscriptsInput): Promise<RecentlyEditedManuscript[]> {
    const params: RequestParam = {
      query: recentlyEditedManuscriptsQuery,
      variables: {
        input: {
          limit,
        },
      },
    };

    const { recentlyEditedManuscripts } = await GraphQLClient.request(params);
    return recentlyEditedManuscripts;
  }
}

const recentlyEditedManuscriptsQuery = gql`
  query RecentlyEditedManuscripts($input: RecentlyEditedManuscriptsInput!) {
    recentlyEditedManuscripts(input: $input) {
      novelId
      novelTitle
      manuscriptKey
      manuscriptTitle
      editedAt
    }
  }
`;
